import type { ReactNode } from 'react';
import { ScheduleCalendar, type AccentTone } from './ScheduleCalendar';
import type { ScheduleEntry } from '../../lib/scheduleParsing';

interface ScheduleSplitLayoutProps<T> {
  entries: ScheduleEntry<T>[];
  activeId: string | null;
  hoveredId: string | null;
  onItemClick: (id: string) => void;
  onItemHover: (id: string | null) => void;
  renderPrimary: (data: T) => ReactNode;
  renderSecondary?: (data: T) => ReactNode;
  accentTone?: (data: T) => AccentTone;
  showWebinarAnchor?: boolean;
  calendarTitle: string;
  calendarSubtitle?: string;
  calendarCountLabel?: string;
  emptyMessage: string;
  renderCard: (entry: ScheduleEntry<T>) => ReactNode;
}

export function ScheduleSplitLayout<T>({
  entries,
  activeId,
  hoveredId,
  onItemClick,
  onItemHover,
  renderPrimary,
  renderSecondary,
  accentTone,
  showWebinarAnchor,
  calendarTitle,
  calendarSubtitle,
  calendarCountLabel,
  emptyMessage,
  renderCard,
}: ScheduleSplitLayoutProps<T>) {
  if (entries.length === 0) {
    return <div className="text-center py-12 text-slate-400">{emptyMessage}</div>;
  }

  return (
    <div className="space-y-6">
      <ScheduleCalendar
        entries={entries}
        activeId={activeId}
        hoveredId={hoveredId}
        onItemClick={onItemClick}
        onItemHover={onItemHover}
        renderPrimary={renderPrimary}
        renderSecondary={renderSecondary}
        accentTone={accentTone}
        showWebinarAnchor={showWebinarAnchor}
        title={calendarTitle}
        subtitle={calendarSubtitle}
        countLabel={calendarCountLabel}
        dense
      />
      <div className="space-y-4">
        {entries.map((entry) => renderCard(entry))}
      </div>
    </div>
  );
}
